const emptyValues = [
  'na',
  'n.a',
  'n.a.',
  'n/a',
  'nil',
  'null',
  '-',
  '#n/a',
  '#'
];

export const ydm_date_regex = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/;

export const OptionalAttr = {
  gender: 'Gender',
  location: 'Location',
  date_of_joining: 'Date of Joining',
  date_of_birth: 'DOB',
  employee_type: 'Employee Type',
  department: 'Department',
  sub_department: 'Sub Department',
  grade: 'Grade',
  performance_rating: 'Performance Rating'
};

export const ManadatoryAttr = {
  employee_email: 'Employee Email',
  manager_email: 'Manager Email'
};

export const getAcceptedHeaders = (mand, optn) => [
  ...Object.keys(mand),
  ...Object.keys(optn)
];

export const InviteUtils = {
  isNullCsvField: val => !val || emptyValues.includes(val?.toLowerCase()),
  validateYmdDate: val => {
    const now = new Date().getTime();
    return val && ydm_date_regex.test(val) && now > new Date(val).getTime();
  },
  validate: (val, attributeType) => {
    if (!InviteUtils.isNullCsvField(val)) {
      if (attributeType === 'DATE') {
        return InviteUtils.validateYmdDate(val) ? false : 'date';
      }
      return false;
    }
    return 'empty';
  },
  buildDemographicsAttributeFromCSV: (acceptedHeaders, row, attributes) => {
    const demographicsInfo = {};
    const warnings = [];
    attributes.forEach(a => {
      if (acceptedHeaders[a]) {
        const validationError = InviteUtils.validate(
          row[a],
          acceptedHeaders[a]
        );
        if (!validationError) {
          demographicsInfo[a] = row[a];
        } else {
          demographicsInfo[a] = '';
          const warningId = `${
            validationError === 'date'
              ? 'INVALID_DATE_ATTRIBUTE_'
              : 'INVALID_ATTRIBUTE_'
          }${a.toUpperCase()}`;
          warnings.push(warningId);
        }
      }
    });
    return [demographicsInfo, warnings];
  },
  isEmailContainAllowedDomain: (domains, ...email) =>
    email.every(e => domains.some(d => e.includes(d))),
  addErrorProp: (user, ...props) => {
    const errors = user.errorProps || [];
    errors.push(...props);
    // eslint-disable-next-line no-param-reassign
    user.errorProps = errors;
    return user;
  },
  getAttributeLabelBasedOnKey: key => {
    const newKey = key.replaceAll('_', ' ');
    return newKey.charAt(0).toUpperCase() + newKey.slice(1);
  }
};

export const createItemData = obj => obj;

const DummyCsvData = {
  employee_email: [
    'dinesh@xyz.com',
    'pakak@xyz.com',
    'amit@xyz.com',
    'robin@xyz.com'
  ],
  manager_email: [
    'founder',
    'dinesh@xyz.com',
    'dinesh@xyz.com',
    'pakak@xyz.com'
  ],
  location: ['Bangalore', 'Mumbai', 'Mumbai', 'Bangalore'],
  date_of_joining: ['2018-08-07', '2020-09-28', '2020-05-21', '2020-01-12'],
  date_of_birth: ['1994-09-05', '1991-07-04', '1990-03-26', '1988-12-16'],
  employee_type: ['Full time', 'Third Party', 'Full time', 'Full time'],
  gender: ['Male', 'Female', 'Male', 'Male'],
  department: ['Corporate', 'Technology', 'Operations', 'Operations'],
  sub_department: ['Corporate', 'Devops', 'Logistics', 'Logistics'],
  grade: ['G0', 'G0', 'G0', 'G0'],
  performance_rating: [
    'Exceeds expectation',
    'Exceeds expectation',
    'Meets expectation',
    'Below expectation'
  ]
};

export const createCsvDownloadTemplate = attributes => {
  const users = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 4; i++) {
    const u = {
      employee_email: DummyCsvData.employee_email[i],
      manager_email: DummyCsvData.manager_email[i]
    };
    attributes.forEach(a => {
      u[a] = DummyCsvData[a] ? DummyCsvData[a][i] : `${a}_value_${i + 1}`;
    });
    users.push(u);
  }
  // return csvjson.toCSV(users, {
  //   delimiter: ',',
  //   wrap: false,
  //   headers: 'relative'
  // });
};

/* eslint-disable no-nested-ternary */
const sortUsersByName = (a, b) =>
  a.name < b.name ? -1 : b.name < a.name ? 1 : 0;
const getSortedUsers = users => {
  const usersWDR = [];
  const usersWoutDR = [];
  users.forEach(m => (m.isEndNode ? usersWoutDR.push(m) : usersWDR.push(m)));
  usersWDR.sort(sortUsersByName);
  usersWoutDR.sort(sortUsersByName);
  return [...usersWDR, ...usersWoutDR];
};
export const createRootHierarchyFromUsers = response => {
  if (!response) return {};
  const users = [...response]?.map(f => {
    const founder = { ...f };
    if (!founder.org_subtree_count) founder.org_subtree_count = 0;
    if (!founder.direct_report_count) founder.direct_report_count = 0;
    founder.refId = founder.user_reference_id;
    founder.parent = '_root';
    founder.isEndNode = founder.org_subtree_count === 0;
    founder.isLoading = false;
    founder.isExpanded = false;
    return founder;
  });
  const sortedFounders = getSortedUsers(users);
  return { _root: sortedFounders };
};

export const createUpdatedHierarchyWithDR = (currentHierarchy, payload) => {
  const {
    data: reports,
    parent: parentId,
    user_reference_id: userId
  } = payload;
  const newHierarchy = { ...currentHierarchy };
  const l1Leaders = newHierarchy._l1 || [];
  const newParent = newHierarchy[parentId]?.find(m => m.refId === userId) || {};
  newParent.isLoading = false;
  newParent.isExpanded = true;
  const users = [...reports]?.map(u => {
    const user = { ...u };
    if (!user.org_subtree_count) user.org_subtree_count = 0;
    if (!user.direct_report_count) user.direct_report_count = 0;
    user.refId = user.user_reference_id;
    user.parent = userId;
    user.isEndNode = newParent.refId ? user.org_subtree_count === 0 : true;
    user.isL1 = !!(newParent.designation === 'FOUNDER');
    user.isChecked = !!user.isChecked;
    user.isLoading = false;
    user.isExpanded = false;
    user.org_subtree_count = newParent.refId ? user.org_subtree_count : 0;
    if (newParent.refId && user.isL1 && !l1Leaders[user.user_reference_id]) {
      l1Leaders[user.user_reference_id] = user;
    }
    return user;
  });
  const sortedUsers = getSortedUsers(users);
  if (newParent.refId) newHierarchy._l1 = l1Leaders;
  newHierarchy[newParent.refId ? userId : '_root'] = sortedUsers;
  return newHierarchy;
};

export const getSubscriptionSubtypeMapping = (
  subscription,
  subscriptionSubtypeMapping
) => {
  const mappingAvailableForSubscription = [];
  subscription.subscription_details.forEach(subs => {
    if (
      subs?.type &&
      subscriptionSubtypeMapping[subs.type] &&
      subs?.status === 'ACTIVE'
    ) {
      mappingAvailableForSubscription.push({
        ...subs,
        ...subscriptionSubtypeMapping[subs.type]
      });
    }
  });
  return mappingAvailableForSubscription;
};

export const isFunctionAssignmentEnabled = (
  subscription,
  subscriptionSubtypeMapping
) => {
  if (subscription && subscription.subscription_details) {
    const subscriptionSubtype = getSubscriptionSubtypeMapping(
      subscription,
      subscriptionSubtypeMapping
    );
    if (
      subscriptionSubtype.length === 1 &&
      subscriptionSubtype[0].disableL1FunctionMapping
    )
      return false;
  }
  return true;
};
